import { defineMessages } from 'react-intl';

export default defineMessages({
  addAddressButtonLabel: {
    id: 'components.Add.title',
    defaultMessage: 'Add address',
  },
  billingAddressTitle: {
    id: 'common.titles.billingAddress',
    defaultMessage: 'Billing address',
  },
  shippingAddressTitle: {
    id: 'common.titles.shippingAddress',
    defaultMessage: 'Shipping address',
  },
  continueButtonLabel: {
    id: 'common.buttons.continue',
    defaultMessage: 'Continue',
  },
  requiredValidationError: {
    id: 'common.titles.validationError',
    defaultMessage: '{field} is required.',
  },
  invalidValidationError: {
    id: 'common.forms.validationInvalidError',
    defaultMessage: 'Please enter a valid {field}.',
  },
  maxLengthValidationError: {
    id: 'common.titles.maxLengthValidationError',
    defaultMessage: 'Max. character count is {maxLength}. Please reduce.',
  },
  shouldMatchError: {
    id: 'common.titles.shouldMatchError',
    defaultMessage: 'Use the same {field} for shipping and billing address',
  },
  sameAsShipping: {
    id: 'common.forms.sameShipping',
    defaultMessage: 'Same as shipping address',
  },
  optional: {
    id: 'common.forms.optional',
    defaultMessage: 'Optional',
  },
  firstName: {
    id: 'common.forms.firstName',
    defaultMessage: 'First name',
  },
  lastName: {
    id: 'common.forms.lastName',
    defaultMessage: 'Last name',
  },
  country: {
    id: 'common.forms.country',
    defaultMessage: 'Country',
  },
  company: {
    id: 'common.forms.company',
    defaultMessage: 'Company',
  },
  addressLineOne: {
    id: 'common.forms.addressLineOne',
    defaultMessage: 'Address Line 1',
  },
  addressLineTwo: {
    id: 'common.forms.addressLineTwo',
    defaultMessage: 'Address Line 2',
  },
  postalCode: {
    id: 'common.forms.postalCode',
    defaultMessage: 'Postal code',
  },
  city: {
    id: 'common.forms.city',
    defaultMessage: 'City',
  },
  phone: {
    id: 'common.forms.phone',
    defaultMessage: 'Phone',
  },
  region: {
    id: 'common.forms.region',
    defaultMessage: 'State',
  },
  vatNumber: {
    id: 'common.forms.vatNumber',
    defaultMessage: 'VAT Number',
  },
  saveButtonLabel: {
    id: 'common.buttons.save',
    defaultMessage: 'Save',
  },
  cancelEditingButtonLabel: {
    id: 'common.buttons.cancelEditing',
    defaultMessage: 'Cancel editing',
  },
  selected: {
    id: 'shop.checkout.address.form.selectedAddress',
    defaultMessage: 'Address',
  },
  businessLabel: {
    id: 'common.titles.businessLabel',
    defaultMessage: 'Business',
  },
  info: {
    id: 'components.alerts.info',
    defaultMessage: 'Info',
  },
  storeChangeTitle: {
    id: 'components.Address.storeChangeTitle',
    defaultMessage: 'Change store location',
  },
  infoCountryChange: {
    id: 'components.Address.infoCountryChange',
    defaultMessage:
      'Changing the country will redirect you to the corresponding store. You might need to add/modify product(s) and proceed to the checkout one more time.',
  },
  continueButton: {
    id: 'common.buttons.continue',
    defaultMessage: 'Continue',
  },
  backButton: {
    id: 'common.buttons.back',
    defaultMessage: 'back',
  },
  phoneMissingError: {
    id: 'common.forms.phoneMissingError',
    defaultMessage:
      'The phone number is missing in the selected address. Please add it and try again.',
  },
});
